import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { createControl } from "../../../create-request/utilities/formUtilities";
import { TextInputModel } from "../../../shared/components/controls/text-input-control/TextInputModel";
import { authNicknameErrorMap } from "../../../shared/utilities/Constants";
import { nicknameAllowedCharacters } from "../../../shared/utilities/regex-patterns";

@Component({
  standalone: false,
  selector: 'mm-wire-authorization-nickname',
  templateUrl: './wire-authorization-nickname.component.html',
  styleUrls: ['./wire-authorization-nickname.component.scss']
})
export class WireAuthorizationNicknameComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  nicknameModel: TextInputModel = {
    controlName: 'authorizationNickname',
    label: 'Authorization nickname',
    hasGreyText: true,
    greyText: '(optional)',
    htmlMaxLength: 50
  };

  constructor() { }

  ngOnInit(): void {
    createControl(this.parentForm, 'authorizationNickname', '', [Validators.pattern(nicknameAllowedCharacters)]);
  }

  get authNickname(): UntypedFormControl {
    return this.parentForm.get('authorizationNickname') as UntypedFormControl;
  }

  get authNicknameIsInvalid() {
    return this.authNickname.dirty && this.authNickname.invalid;
  }

  get authNicknameValidationError() {
    if (this.authNickname && this.authNickname.errors) {
      const errorKeys: string[] = Object.keys(this.authNickname.errors ?? {});
      if (errorKeys.length > 0) {
        return authNicknameErrorMap[
          errorKeys[0] as keyof typeof authNicknameErrorMap
        ];
      }
    }
  }
}
